import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-editor__icons"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_Picker = _resolveComponent("Picker")!
  const _component_FadeTransition = _resolveComponent("FadeTransition")!
  const _component_EditorContent = _resolveComponent("EditorContent")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-editor", {
      'text-editor__bordered': !_ctx.borderless,
      'text-editor__focus': _ctx.isFocused,
      'text-editor__disabled': !_ctx.editable,
      'text-editor--has-icons': _ctx.hasIcons,
      'text-editor--loading': _ctx.loading
    }]),
    ref: "rootRef",
    onDrop: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.onImageDropped($event)), ["prevent"]))
  }, [
    (_ctx.editable && !_ctx.borderless)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "text-editor__menu",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editor.chain().focus()))
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showEmojiPicker = !_ctx.showEmojiPicker), ["stop"])),
            class: _normalizeClass(["menu-button emoji-toggle", { 'is-active': _ctx.showEmojiPicker }])
          }, [
            _createVNode(_component_AppIcon, { name: "face-grin" })
          ], 2),
          _createVNode(_component_FadeTransition, { duration: { enter: 500, leave: 200 } }, {
            default: _withCtx(() => [
              (_ctx.showEmojiPicker)
                ? (_openBlock(), _createBlock(_component_Picker, {
                    key: 0,
                    class: _normalizeClass(["text-editor__emoji-picker", { 'text-editor__emoji-picker__expands-up': _ctx.emojiPickerExpandsUp }]),
                    title: "Pick your emoji..",
                    emoji: "point_up",
                    native: true,
                    emojiSize: 24,
                    perLine: 9,
                    data: _ctx.emojiData,
                    showSearch: !_ctx.isMobileView,
                    autoFocus: !_ctx.isMobileView,
                    onSelect: _cache[1] || (_cache[1] = (value) => _ctx.onEmojiSelect(value)),
                    showSkinTones: false,
                    skin: 1,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["class", "data", "showSearch", "autoFocus"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.allowImages)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _withDirectives(_createElementVNode("input", {
                  ref: "inputFile",
                  type: "file",
                  accept: "image/*",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onImageInput($event)))
                }, null, 544), [
                  [_vShow, false]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$refs.inputFile.value = null, _ctx.$refs.inputFile.click()), ["prevent"])),
                  class: "menu-button"
                }, [
                  _createVNode(_component_AppIcon, { name: "image-solid" })
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('bold') }])
          }, [
            _createVNode(_component_AppIcon, { name: "bold" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('italic') }])
          }, [
            _createVNode(_component_AppIcon, { name: "italic" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editor.chain().focus().toggleUnderline().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('underline') }])
          }, [
            _createVNode(_component_AppIcon, { name: "underline" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editor.chain().focus().toggleStrike().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('strike') }])
          }, [
            _createVNode(_component_AppIcon, { name: "strikethrough" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editor.chain().focus().toggleBulletList().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('bulletList') }])
          }, [
            _createVNode(_component_AppIcon, { name: "list-unordered" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editor.chain().focus().toggleTaskList().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('taskList') }])
          }, [
            _createVNode(_component_AppIcon, { name: "list-check" })
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editor.chain().focus().toggleCodeBlock().run())),
            class: _normalizeClass(["menu-button", { 'is-active': _ctx.editor.isActive('codeBlock') }])
          }, [
            _createVNode(_component_AppIcon, { name: "code" })
          ], 2),
          _createElementVNode("button", {
            class: "menu-button",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.mentionUser && _ctx.mentionUser(...args)))
          }, [
            _createVNode(_component_AppIcon, { name: "at-solid" })
          ]),
          (_ctx.isJiraEnabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.mentionJira && _ctx.mentionJira(...args))),
                class: "menu-button"
              }, [
                _createVNode(_component_AppIcon, { name: "jira-black" })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EditorContent, {
      editor: _ctx.editor,
      ref: "editorContentRef"
    }, null, 8, ["editor"]),
    (_ctx.hasIcons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.allowCancel)
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                theme: "secondary",
                onClick: _ctx.cancel,
                disabled: _ctx.loading || _ctx.isProcessingImage
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_AppButton, {
            class: _normalizeClass({ 'text-editor__button-submit-with-icon' : !_ctx.buttonText }),
            icon: !_ctx.buttonText ? 'vector' : '',
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('user-action:post'))),
            loading: _ctx.loading,
            disabled: !_ctx.allowPost
          }, {
            default: _withCtx(() => [
              (_ctx.buttonText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.buttonText), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "icon", "loading", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 34))
}